<template>
  <section v-if="listaArquivos.length">
    <div v-if="statusDocumento === 'Em Atendimento'" class="content">
      <transition name="fade">
        <Mensagem
          icon="task_alt"
          title="Estamos validando seus documentos!"
          description="Iremos entrar em contato assim que seus documentos forem validados, para prosseguir o cadastro do plano."
          link="/produto/cdl-consultor/cdl-saude"
        />
      </transition>
    </div>
    <div v-else class="content">
      <transition name="fade">
        <Termo
          @click="salvarAceite"
          @fechar="fecharAceite"
          :cpfTitular="cpfTitular"
          v-show="exibirTermo"
        />
      </transition>
      <transition name="fade">
        <div v-show="!exibirTermo">
          <Titulo
            title="Envie seus documentos"
            description="Documentos necessários para inclusão de vidas/plano"
          />
          <div class="row no-gutters mt-4">
            <div class="col-12" v-if="msgChamado">
              <div class="alert alert-warning">ATENÇÃO: {{ msgChamado }}</div>
            </div>
            <div
              class="col-md-4"
              :class="{ 'd-none d-md-block': registroSel !== null }"
            >
              <div class="lista-botoes">
                <button
                  type="button"
                  @click="selecionaCadastro(index)"
                  :class="{ active: index === registroSel }"
                  v-for="(registro, index) in registros"
                  :key="index"
                >
                  <div class="label">
                    {{
                      registro.cpF_DEPENDENTE === "" ? "Titular" : "Dependente"
                    }}
                  </div>
                  <div class="value">
                    {{ registro.nome }}
                  </div>
                  <div
                    v-if="!registro.arquivosConcluido"
                    class="text-danger text-small d-flex align-items-center"
                  >
                    <span class="material-icons mr-1 text-small">
                      warning_amber
                    </span>
                    Arquivos incompletos
                  </div>
                  <div v-else class="text-success text-small font-weight-bold">
                    <span class="material-icons mr-1 text-small"> done </span>
                    Arquivos completos
                  </div>
                </button>
              </div>
            </div>
            <div
              class="col-md-8 d-md-block"
              :class="{ 'd-none': registroSel === null }"
            >
              <div
                class="arquivos-form p-4"
                :style="{ 'min-height': registros.length * 110 + 'px' }"
                :class="{ 'd-none': registroSel === null }"
              >
                <FormulateForm name="documentos" v-model="values">
                  <div
                    v-for="(registro, i) in registros"
                    :key="i"
                    :id="i"
                    class="lista-registros"
                    v-show="i === registroSel"
                  >
                    <div
                      class="mb-4 d-block d-md-none"
                      v-show="i === registroSel"
                    >
                      <div class="label">{{ registro.titularidade }}</div>
                      <div class="value">{{ registro.nome }}</div>
                    </div>
                    <div
                      v-show="i === registroSel"
                      v-for="(arquivo, index) in registro.listaDocsObrigatorios"
                      :key="index"
                      class="lista-docs"
                    >
                      <FormulateInput
                        type="file"
                        :name="'input_' + i + index"
                        :label="arquivo.documento"
                        @change="
                          salvar('input_' + i + index, i, arquivo.documento)
                        "
                        @file-removed="remover('input_' + i + index)"
                        validation="mime:image/jpeg,image/gif,image/png,application/pdf,image/x-eps"
                      />
                    </div>
                  </div>
                  <div
                    v-if="registroSel !== null"
                    class="d-block d-md-none text-center mt-4"
                  >
                    <button
                      @click="registroSel = null"
                      class="btn btn-block btn-outline-secondary"
                    >
                      VOLTAR
                    </button>
                  </div>
                </FormulateForm>
              </div>
              <div :class="registroSel === null ? 'd-md-flex h-100' : 'd-none'">
                <div class="alert alert-info d-flex align-items-center">
                  <span class="material-icons"> arrow_back_ios </span> Clique
                  nos botões ao lado para enviar o restante dos arquivos.
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-5 flex-column-reverse flex-md-row">
            <div class="col-md-4 col-lg-2 mt-3 mt-md-0">
              <Botao
                title="Voltar"
                link="/produto/cdl-consultor/cdl-saude-cadastro"
                nameClass="btn btn-outline-secondary btn-lg btn-block"
                >VOLTAR</Botao
              >
            </div>
            <div class="col-md-5 col-lg-4">
              <Botao
                title="Próximo"
                @click="
                  disabled || loading ? (exibirTermo = false) : proximaEtapa()
                "
                nameClass="btn btn-cta btn-lg btn-block font-weight-bold"
                :class="{ disabled: disabled }"
              >
                <span
                  class="spinner-grow spinner-grow-sm pr-2"
                  role="status"
                  aria-hidden="true"
                  v-show="loading"
                ></span>
                PRÓXIMO</Botao
              >
            </div>
          </div>
        </div>
      </transition>
      <div class="py-5"></div>
    </div>
  </section>
  <section v-else>
    <loading />
  </section>
</template>

<script>
import Titulo from "@/components/TituloPaginas";
import Botao from "@/components/botoes/Botao";
import Mensagem from "@/components/alertas/Mensagem";
import Termo from "./Termo";

export default {
  name: "ListaVidas",
  components: { Titulo, Botao, Mensagem, Termo },
  data() {
    return {
      disabled: true,
      produto: {
        nome: "CDL Saúde",
        id: "SPC Saude",
      },
      breadcrumb: [
        {
          nome: "CDL Saúde",
          id: "CDL Saude",
          link: "/produto/cdl-saude",
        },
        {
          nome: "Envio de Documentos",
          id: "envio_de_documentos",
        },
      ],
      values: {},
      listaArquivos: [],
      arquivosEnviados: [],
      registros: [],
      listaCpf: [],
      registroSel: null,
      arquivosSelecionados: {},
      statusDocumento: "",
      aceiteTermo: false,
      exibirTermo: false,
      cpfTitular: null,
      msgChamado: null,
      loading: false,
      codSocio: null,
    };
  },
  methods: {
    async montaDados() {
      var result = [];
      await this.$http
        .get(
          `/api/CdlBh/ConsultarSamVidaArta?cpfTitular=${this.urlParams.cpfTitular}&codSocio=${this.codSocio}`
        )
        .then((response) => {
          result = response.data.lista;
        });

      result.forEach((registro) => {
        if (registro.cpF_DEPENDENTE === "") {
          this.statusDocumento = registro.statuschamado;
          this.statusDocumento = "Em Atendimento";
        }
        this.msgChamado = registro.comentariochamado;

        if (registro.statuschamado === "Reprovado") {
          this.disabled = false;
        }

        this.cpfTitular = registro.cpF_TITULAR;

        this.listaCpf.push(registro.cpF_TITULAR);
        registro.arquivosEnviados = false;
        this.registros.push(registro);
        this.listaArquivos.push(registro.listaDocsObrigatorios);

        for (const dependente of registro.dependentes) {
          this.listaCpf.push(dependente.cpF_DEPENDENTE);
          dependente.arquivosEnviados = false;
          this.registros.push(dependente);
          this.listaArquivos.push(dependente.listaDocsObrigatorios);
        }
      });

      this.selecionaCadastro(0);
      this.aceiteTermo = window.sessionStorage.getItem(
        "termoAceiteArquivos",
        this.checkAceite
      );
    },
    selecionaCadastro(id) {
      this.registroSel = id;
    },
    remover(name) {
      this.arquivosEnviados = this.arquivosEnviados.filter(
        (e) => e.id !== name
      );
      this.registros[this.registroSel].arquivosConcluido = false;

      if (this.statusDocumento !== "Reprovado") {
        this.disabled = true;
      }
    },
    async salvar(name, vida, filename) {
      this.arquivosEnviados.push({
        file: this.values[`${name}`].fileList,
        iVida: vida,
        id: name,
        filename: filename,
      });

      if (this.statusDocumento !== "Reprovado") {
        this.disabled = !(await this.validarDocumentos());
      }
      const qtdArquivos = this.arquivosEnviados.filter(
        (el) => el.iVida === this.registroSel
      );

      if (
        qtdArquivos.length + 1 >=
        this.registros[this.registroSel].listaDocsObrigatorios.length
      ) {
        this.registros[this.registroSel].arquivosConcluido = true;
      } else {
        this.registros[this.registroSel].arquivosConcluido = false;
      }
    },
    proximaEtapa() {
      if (this.statusDocumento === "Reprovado") {
        this.enviarDocumentos();
      } else {
        this.enviarDocumentos();
      }
    },
    async enviarDocumentos() {
      if (
        (await this.validarDocumentos()) ||
        this.statusDocumento === "Reprovado"
      ) {
        this.loading = true;
        const form = new FormData();

        this.arquivosEnviados.forEach((el) => {
          form.append(
            "files",
            el.file[0],
            el.filename + el.file[0].name.substr(-4)
          );
        });

        this.listaCpf.forEach((el) => {
          form.append("cpf", el);
        });

        await this.$http
          .post(
            `/api/GestaoSaude/IncluirUsuariosPlanoVidaSaude?codSocio=${this.codSocio}`,
            form
          )
          .then((response) => {
            if (response.data.success && !response.data.erroAplicacao) {
              if (this.statusDocumento !== "Reprovado") {
                this.enviarAceite();
              } else {
                this.statusDocumento = "Em Atendimento";
              }
              this.loading = false;
            }
          })
          .catch((error) => {
            console.error(error);
            this.$toast.open({
              message: "Erro no envio dos seus arquivos, tente novamente.",
              type: "error",
            });
            this.loading = false;
          });
      }
    },
    async validarDocumentos() {
      for await (const [vida, el] of this.listaArquivos.entries()) {
        for await (const i of el.keys()) {
          var name = "input_" + vida + i;
          if (typeof this.values[`${name}`] !== "undefined") {
            if (this.values[`${name}`].files.length === 0) {
              return false;
            }
          } else {
            return false;
          }
        }
      }
      return true;
    },
    async enviarAceite() {
      if (!sessionStorage.ip) {
        await fetch(process.env.VUE_APP_IP_API + "?format=json")
          .then((x) => x.json())
          .then(({ ip }) => {
            sessionStorage.ip = ip;
          });
      }
      await this.$http
        .post(`/api/Drive/AceitarTermoSaude`, {
          dtVersao: new Date(),
          dtAceite: new Date(),
          ipOrigem: sessionStorage.ip,
          browserData: navigator.appVersion,
          cpfTitular: this.cpfTitular,
        })
        .then((response) => {
          if (response.status === 200) {
            this.statusDocumento = "Em Atendimento";
          }
        })
        .catch((error) => {
          console.error(error);
          this.$toast.open({
            message: "Erro no envio dos seus arquivos, tente novamente.",
            type: "error",
          });
          this.loading = false;
        });
    },
    salvarAceite(payload) {
      this.aceiteTermo = payload.checkAceite;
      if (this.aceiteTermo) {
        this.enviarDocumentos();
      }
    },
    fecharAceite() {
      this.exibirTermo = false;
    },
  },
  computed: {
    urlParams() {
      return this.$route.params;
    },
  },
  created() {
    this.$store.commit("UPDATE_PRODUTO", this.produto);
    this.$store.commit("UPDATE_BREADCRUMB", this.breadcrumb);
    this.codSocio = localStorage.getItem("associadoSelecionado");
    this.montaDados();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_vars.scss";
.status {
  font-size: 14px;
  &.status-pendente {
    color: $success;
  }
}
.label {
  font-weight: 300;
  font-size: 1rem;
  margin-bottom: 3px;
  text-transform: capitalize;
}
.value {
  font-weight: bold;
  font-size: 1rem;
  text-transform: uppercase;
  color: #000;
  line-height: 1.4;
}
.lista-botoes {
  button {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 20px;
    border: 0;
    background: white;
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
    margin-bottom: 10px;
    &.active {
      background: $dark-100;
    }
  }
}
.lista-registros /deep/ {
  .lista-docs {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
}
.arquivos-form /deep/ {
  @import "../../../../node_modules/@braid/vue-formulate/themes/snow/snow.scss";
  background: $dark-100;
  border-top-right-radius: 6px;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  .formulate-input {
    label {
      margin-bottom: 5px;
    }
  }
  .formulate-input-upload-area {
    .formulate-input-upload-area-mask {
      background: white;
    }
  }
  .formulate-input[data-classification="file"]
    .formulate-files
    .formulate-file {
    background: white;
  }
}

@media screen and (max-width: 768px) {
  .lista-botoes {
    button {
      border-radius: 6px;
    }
  }
  .arquivos-form /deep/ {
    border-radius: 6px;
  }
}
</style>
